import { createSlice } from '@reduxjs/toolkit'

const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
  ? 'dark'
  : 'light'
const userTheme = localStorage.getItem('theme')

const initialState = {
  theme: userTheme || systemTheme,
  loading: false,
  lang: 'zh'
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalState(state, action) {
      Object.assign(state, action.payload)

      if (action.payload.theme) {
        const body = document.body

        if (action.payload.theme === 'dark') {
          if (!body.hasAttribute('theme-mode')) {
            body.setAttribute('theme-mode', 'dark')
          }
        } else {
          if (body.hasAttribute('theme-mode')) {
            body.removeAttribute('theme-mode')
          }
        }
      }
    },
    setLang(state, action) {
      console.log(state, action.payload, action)
      Object.assign(state, action.payload)
    }
  }
})

export const { setGlobalState, setLang } = globalSlice.actions

export default globalSlice.reducer
